const validateEmailAddress = (email: string): boolean => {
  const expression = /\S+@\S+\.\S+/;
  return expression.test(email.toLowerCase());
}
export default validateEmailAddress;